import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./base-query";

export const rootApi = createApi({
  reducerPath: "rootApi",
  tagTypes: [
    "person",
    "file",
    "note",
    "auth",
    "profile",
    "pinCode",
    "calendarEvent",
    "authStatus",
    "sync",
    "search",
    "personInfo",
    "subscription",
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
